import React from 'react';
import Icon from '../Icon/Icon';
import { VALIDATION_CONFIG, ValidationType } from './validationConfig';

type ValidationMessageProps = {
  id?: string;
  text: string;
  type: ValidationType;
};

function FormValidationMessage({ id, text, type }: ValidationMessageProps): JSX.Element {
  const config = VALIDATION_CONFIG[type];

  return (
    <span
      id={id}
      className={`validation-message validation-message--${type}`}
      role={type === 'error' ? 'alert' : 'status'}
    >
      {/* color="inherit" makes the icon follow the message text color
          (--ui-color-notification-*-text / -stroke) so icon and label match. */}
      <Icon name={config.messageIcon} size="xs" color="inherit" />
      {text}
    </span>
  );
}

export default FormValidationMessage;
